import { onScrollTo } from './../utility/onScrollTo'

export default function() {
	onScrollTo(
		'.animate-on-view', 
		el => el.classList.add('animate'), 
		{ offset: -200 }
	)
}